import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CompanyComponent } from '../components/company/company.component';
import { CompanyDashboardComponent } from '../components/company/dashboard/company-dashboard.component';
import { DatabaseComponent } from '../components/company/database/database.component';
import { CompanyOrderListComponent } from '../components/company/order-list/company-order-list.component';
import { PhotographersComponent } from '../components/company/photographers/photographers.component';
import { TemplatesComponent } from '../components/company/templates/templates.component';
import { AccountComponent } from '../shared/components/account/account.component';
import { ManagementComponent } from '../shared/components/management/management.component';
import { SidenavTypeEnum } from '../shared/models/sidebar-group.models';
import { PhotographerOrdersComponent } from '../components/company/photographer-orders/photographer-orders.component';
import { SettingsComponent } from '../components/company/settings/settings.component';
import { AuthorizationGuardService } from '../shared/libs/auth/authorization-guard.service';
import { CompanyRole } from '../models/shared/enums/company-role.enum';

const routes: Routes = [
  {
    path: '',
    component: CompanyComponent,
    data: { sidenavType: SidenavTypeEnum.company },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: CompanyDashboardComponent,
        data: { title: 'Dashboard | Company | BasicStudios', roles: [CompanyRole.DASHBOARD_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'order-list',
        component: CompanyOrderListComponent,
        data: { title: 'Order list | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'styles',
        component: DatabaseComponent,
        data: { title: 'Styles | Company | BasicStudios', roles: [CompanyRole.STYLES_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'photographers',
        component: PhotographersComponent,
        data: { title: 'Photographers | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'photographer-orders/:photographerId',
        component: PhotographerOrdersComponent,
        data: { title: 'Photographer Orders | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_READ] },
        // canActivate:[AuthorizationGuardService]
      },
      {
        path: 'templates',
        component: TemplatesComponent,
        data: { title: 'Templates | Company | BasicStudios', roles: [CompanyRole.TEMPLATES_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'management',
        component: ManagementComponent,
        data: { title: 'Management | Photographer | BasicStudios', roles: [CompanyRole.MANAGEMENT_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'account',
        component: AccountComponent,
        data: { title: 'Account | Company | BasicStudios', roles: [CompanyRole.ACCOUNT_READ] },
        canActivate:[AuthorizationGuardService]
      },
      {
        path: 'settings',
        component: SettingsComponent,
        data: { title: 'Account | Company | BasicStudios' },
        canActivate:[AuthorizationGuardService]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ]
})
export class CompanyRouting { }
